import { render, staticRenderFns } from "./RegisterUser.vue?vue&type=template&id=c083006a&scoped=true&"
import script from "./RegisterUser.vue?vue&type=script&lang=js&"
export * from "./RegisterUser.vue?vue&type=script&lang=js&"
import style0 from "./RegisterUser.vue?vue&type=style&index=0&id=c083006a&scoped=true&lang=css&"
import style1 from "./RegisterUser.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c083006a",
  null
  
)

export default component.exports